module.exports = __webpack_public_path__ + "static/img/13.a9eb081.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/1/eng/13.png
// module id = UfWk
// module chunks = 0